export const img = ["./images/img_lamp3.jpg"
, "./images/img_lamp4.jpg", "./images/img_lamp5.jpg", "./images/img_lamp2.jpg"]